import { Component, forwardRef } from '@angular/core';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-equipmentactivity-dropdown',
  templateUrl: './EquipmentActivityDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => EquipmentActivityDropdownComponent)}]
})
export class EquipmentActivityDropdownComponent extends BaseDropdownComponent {

    equipmentClasses: ent.EquipmentActivity[] = [];

    constructor(private domainDataService: serv.DomainDataService) 
    {
        super();
    }


    ngOnInit(): void {
    }

    public load(){
        this.domainDataService.getEquipmentActivities().subscribe(x=> this.onGetEquipmentActivitiesDone(x));
    }
    
    onGetEquipmentActivitiesDone(items: ent.EquipmentActivity[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
        this.value = this.selectedID;
    }

}